import {
  useCreateCommentMutation,
  useGetCommentQuery,
  useUpdateCommentMutation,
} from '@entities/common/commonQueries/index.ts';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { PageBackButton } from '@features/common/PageBackButton/index.tsx';
import { useCloseFormDialogModal } from '@shared/hooks/useCloseFormDialogModal/useCloseFormDialogModal.ts';
import { Card, ListBody, PageHead, TextareaM, TextButton } from '@shared/ui/index.ts';
import { Loader } from '@src/library/components/common/index.ts';
import * as st from './styles.module.scss';

type PT = {};

export const CommentEdit = ({}: PT) => {
  const { commentId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { doCloseFormWithDialogModal } = useCloseFormDialogModal();

  const [commentBody, setCommentBody] = useState('');

  const article = location.state?.article;
  const program = location.state?.program;
  const type = location.state?.type;
  const pageTitle = location.state?.pageTitle;

  const isNewComment = useMemo(() => commentId === 'new', [commentId]);

  const { data, isFetching } = useGetCommentQuery(commentId, {
    skip: isNewComment,
  });

  const [createComment, { isLoading: isCreatingLoading }] = useCreateCommentMutation();

  const [updateComment, { isLoading: isUpdatingLoading }] = useUpdateCommentMutation();

  const onReadyButtonClick = useCallback(async () => {
    const dataForBack = {
      text: commentBody,
      article,
      program,
    };

    if (type === 'answer') {
      await createComment({
        ...dataForBack,
        answer_to: Number(commentId),
      });
    } else {
      if (isNewComment) {
        await createComment(dataForBack);
      } else {
        await updateComment({ ...dataForBack, id: commentId as string });
      }
    }
    navigate(-1);
  }, [
    navigate,
    commentBody,
    article,
    program,
    type,
    createComment,
    isNewComment,
    updateComment,
    commentId,
  ]);

  useEffect(() => {
    if (data && type !== 'answer') {
      setCommentBody(data.text);
    }
  }, [data, type]);

  return (
    <>
      <PageHead
        Center={pageTitle}
        Left={
          <PageBackButton
            onClick={doCloseFormWithDialogModal({
              onModalConfirm: () => navigate(-1),
              isShouldModalOpen:
                isNewComment || type === 'answer' ? commentBody !== '' : commentBody !== data?.text,
            })}
          />
        }
        Right={
          <TextButton
            type="button"
            onClick={onReadyButtonClick}
            disabled={isCreatingLoading || isUpdatingLoading}
          >
            Готово
          </TextButton>
        }
      />
      <ListBody className={st.body}>
        <Card className={st.card}>
          {isFetching ? (
            <Loader />
          ) : (
            <TextareaM
              value={commentBody}
              onChange={(text) => setCommentBody(text.currentTarget.value)}
              className={st.textarea}
            />
          )}
        </Card>
      </ListBody>
    </>
  );
};
